<template>
  <div class="chart" ref="chart"></div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import * as echarts from "echarts";

export default {
  name: "ConsoleChart3",
  extends: BaseVue,
  props: {
    year: {
      require: true,
      default: new Date().getFullYear()
    },
  },
  data() {
    return {
      option: {
        color: ['#2b85e4', '#19be6b'],
        grid:{
          bottom:20,
          left: 50,
          right: 50,
          top: 50
        },
        title: {
          text: "月度运行统计",
          left: "center",
          textStyle: {
            fontSize:14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['新风','空调'],
          top: 20
        },
        toolbox: {
          show: true,
          left: 'right',
          top: 0,
          feature: {
            mark: {show: true},
            saveAsImage: {show: true}
          }
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            name: '小时',
            type: 'value',
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '新风',
            type: 'bar',
            label: {
              show: false
            },
            barMaxWidth: 10,
            data: []
          },
          {
            name: '空调',
            type: 'bar',
            label: {
              show: false
            },
            barMaxWidth: 10,
            data: []
          }
        ]
      },
      chart: null
    }
  },
  created() {
    this.$nextTick(()=> {
      this.chart = echarts.init(this.$refs["chart"]);
      this.chart.setOption(this.option);
    });
  },
  watch: {
    year: {
      immediate: true,
      handler() {
        this.query();
      }
    }
  },
  methods: {
    query() {
      this.postForm("/device-month-info/monthAvgByArea",{
        y: this.year
      }).then((dr)=>{
        this.option.xAxis[0].data = []
        this.option.series[0].data = [];
        this.option.series[1].data = [];
        dr.rows.forEach((item)=>{
          this.option.xAxis[0].data.push(item.m+"月");
          this.option.series[0].data.push(item.fanRunHours);
          this.option.series[1].data.push(item.acRunHours);
        });
        this.chart.setOption(this.option);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/css/variables";
.chart{
  padding: 10px;
  height: 250px;
  border: 1px solid $color-border-primary;
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>